import * as React from 'react';

/* eslint-disable react/prop-types */
export type ExternalLinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement>;

export const ExternalLink = React.forwardRef<
  HTMLAnchorElement,
  ExternalLinkProps
>(function ExternalLink(
  {
    children,
    target,
    rel,
    ...props
  }: React.PropsWithChildren<ExternalLinkProps>,
  ref: React.Ref<HTMLAnchorElement>
) {
  return (
    <a
      ref={ref}
      target={target ?? '_blank'}
      rel={rel ?? 'noopener noreferrer'}
      className="group inline-flex items-start gap-1 decoration-dotted underline-offset-1 text-blue-900 border-0"
      {...props}
    >
      {children}
      <div className="w-4 h-4">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 12">
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeWidth="1.5"
            d="m3.3 9.7 5.2-5.2M4.5 4h4.4a.1.1 0 0 1 .1.1v4.4"
          />
        </svg>
      </div>
    </a>
  );
});
